/**
 * Add new source to store
 * @type {string}
 */
export const ADD_SOURCE = 'LITERATURE_WIZARD/ADD_SOURCE';

/**
 * Add multiple sources to store
 * @type {string}
 */
export const ADD_SOURCES = 'LITERATURE_WIZARD/ADD_SOURCES';

/**
 * Update source
 * @type {string}
 */
export const UPDATE_SOURCE = 'LITERATURE_WIZARD/UPDATE_SOURCE';

/**
 * Set contribution type for source
 * @type {string}
 */
export const SET_CONTRIBUTION = 'LITERATURE_WIZARD/SET_CONTRIBUTION';

/**
 * Update comment for source
 * @type {string}
 */
export const UPDATE_COMMENT = 'LITERATURE_WIZARD/UPDATE_COMMENT';

/**
 * Update source _id with db id
 * @type {string}
 */
export const UPDATE_ID = 'LITERATURE_WIZARD/UPDATE_ID';

/**
 * Add shortlist element
 * @type {string}
 */
export const SHORTLIST_ADD = 'LITERATURE_WIZARD/SHORTLIST_ADD';

/**
 * Remove shortlisted element
 * @type {string}
 */
export const SHORTLIST_REMOVE = 'LITERATURE_WIZARD/SHORTLIST_REMOVE';

/**
 * Reset sources
 * @type {string}
 */
export const RESET = 'LITERATURE_WIZARD/RESET';

/**
 * Toggle list element selection
 * @type {string}
 */
export const TOGGLE_SELECT = 'LITERATURE_WIZARD/TOGGLE_SELECT';

/**
 * Select every source
 * @type {string}
 */
export const SELECT_ALL = 'LITERATURE_WIZARD/SELECT_ALL';

/**
 * Deselect every selected source
 * @type {string}
 */
export const DESELECT_ALL = 'LITERATURE_WIZARD/DESELECT_ALL';

/**
 * Delete sources
 */
export const DELETE_SOURCES = 'LITERATURE_WIZARD/DELETE_SOURCES';



// WEBPACK FOOTER //
// ./src/action_types/literatureWizardActionTypes.ts